import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FiRefreshCw } from "react-icons/fi";
import { renderFrequencyLabel } from "src/lib/render-frequency-label";
import Currency from "src/react/components/currency";
import { color } from "src/styles/variables";
import OutOfStock from "src/react/components/out-of-stock";

function CheckoutReviewProduct({ product, ...props }) {
  const productOptions = [].concat(product.options || []);
  const engraving = productOptions
    .map((option) => option.engraved_initials)
    .filter((option) => !!option)
    .join(", ");
  const isOutOfStock = product.outOfStock;

  return (
    <ProductWrapper data-selector={`Review-Product-${product.id}`} {...props}>
      <ProductImage src={product.image} isDisabled={isOutOfStock} />
      <ProductDescription>
        <ProductName>{product.name}</ProductName>
        {isOutOfStock && <OutOfStock />}
        {!!product.frequency && !isOutOfStock && (
          <ProductExtras>
            <RefreshIcon size={15} />
            <span>every {renderFrequencyLabel(product.frequency)}</span>
          </ProductExtras>
        )}
        {!!product.quantity && !isOutOfStock && (
          <ProductExtras
            data-selector={`Review-Product-${product.id}-quantity`}
          >
            Quantity: {product.quantity}
          </ProductExtras>
        )}
        {!!engraving && (
          <ProductExtras
            data-selector={`Review-Product-${product.id}-engraving`}
          >
            Engraving: {engraving}
          </ProductExtras>
        )}
      </ProductDescription>
      <Price data-selector={`Review-Product-${product.id}-Price`}>
        {product.isFree ? "FREE" : <Currency value={product.priceInPence} />}
      </Price>
    </ProductWrapper>
  );
}

CheckoutReviewProduct.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    priceInPence: PropTypes.number.isRequired,
    isFree: PropTypes.bool,
    quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    frequency: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};

export default CheckoutReviewProduct;

const RefreshIcon = styled(FiRefreshCw)`
  opacity: 0.8;
  vertical-align: middle;
  margin-right: 5px;
`;

const ProductWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 10px;
  ${({ noBorder }) =>
    !noBorder && `border-bottom: 1px solid ${color.shipGrey};`};
`;

const ProductImage = styled.img`
  width: 75px;
  height: 75px;
  margin-right: 10px;
  ${({ isDisabled }) => isDisabled && `filter: grayscale(1);`}
`;

const ProductDescription = styled.div`
  flex-grow: 1;
  margin-right: 5px;
  font-size: 14px;
`;

const ProductName = styled.p`
  font-weight: 600;
  margin-bottom: 0;
`;

const ProductExtras = styled.p`
  margin-bottom: 0;
`;

const Price = styled.div`
  color: ${color.midBlue};
  font-weight: 400;
`;
